// src/api/quickquote/quickQuoteApi.js
import axiosClient from '../axiosClient';

export const quickQuoteApi = {
  getItemsByCasNumbers: async (casNumbers) => {
    try {
      // Convert array to comma-separated string for query parameter
      const casString = casNumbers.join(',');
      
      const params = new URLSearchParams({
        casNumbers: casString
      });

      console.log('📦 Fetching items for CAS numbers:', casNumbers);

      const data = await axiosClient.get(`/quick-quote/items?${params.toString()}`);
      
      console.log('✅ Quick quote items received:', data);
      return data;
    } catch (error) {
      console.error('❌ Error fetching quick quote items:', error);
      throw error;
    }
  }
};